<template>
  <div class="open-time">
    <h1 class="m-font-1 ml-36">语音导览服务</h1>
    <div class="open-content">
      <div class="bb">
        <div class="m-font-5 pf-regular mb-50">收费语音导览服务</div>
        <p class="mb-50">
          辽宁省博物馆提供语音导览服务，语音导览辑录了辽宁省博物馆的常设展览（古代辽宁展、中国历代玺印展、中国古代铜镜展、中国古代佛教造像展、辽代陶瓷展、明清玉器展、明清瓷器展、中国古代碑志展）以及正在制作中的往期临展包括（山高水长——唐宋八大家文物精品展、书画展）等。
        </p>
        <p class="mb-50">如需使用此项服务请前往辽宁省博物馆自助导览服务驿站处租赁（位于序厅环岛服务台）。</p>
      </div>
      <div class="bt">
        <p class="week mb-50">语音导览服务时间为周二至周日9:00 - 16:00，租金为20元/次（10分钟内归还免费），需缴纳押金为200元/次，使用语音导览服务完毕后退还押金。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;
  h1 {
    margin-bottom: 60px;
    // font-size: 44px;
    font-weight: 400;
    color: #000000;
  }

  .open-content {
    .date {
      font-weight: 400;
      color: #000000;
      margin-bottom: 20px;
    }

    .bb {
      padding: 0 36px;
      border-bottom: 1px solid rgba(215, 215, 215, 1);
      padding-bottom: 30px;
    }

    .bt {
      padding: 50px 36px 0;
    }

    p {
      font-size: 32px;
      color: #010101;
      font-family: pf-light;
      line-height: 38px;
      text-indent: 16px;
      line-height: 48px;
    }
  }
}
</style>